import React, { useEffect, useState } from 'react'
import styles from './summaryDetails.module.scss'
import Details from '../Details'
import Robotik from '../../../../icons/robbot.svg'
import Edit from '../../../../icons/edit.svg'
import Delete from '../../../../icons/delete.svg'
import {
  createForm,
  getAuthUserPdf,
  getPdf,
  submitReimbursement,
} from '../../../../api/formApi'
import cx from 'classnames'
import { getReimbursements, upDateEmail } from '../../../../api/userApi'
import {
  setUpdateAuthorizedPerson,
  setUpdateCareQuizQuestions,
  setUpdateLegalRepresentations,
  setUpdateRepresentationByCommerciallyActive,
  setUpdateRepresentationByPrivateIndividual,
  setUpdateRepresentativePerson,
} from '../../../../redux/actions/updateState'
import { useDispatch, useSelector } from 'react-redux'
import { setToastNotification } from '../../../../redux/actions/toastNotification'
import {
  setAdditionalEmail,
  setFormEdit,
  updateQuiz,
} from '../../../../redux/actions/quizQuestions'
import AddEmail from '../../../../icons/addEmail.svg'
import {
  closeConfirmationModal,
  setConfirmationModal,
} from '../../../../redux/actions/confirmationModal'
import AddEmailComponent from '../NestedComponentOfModal/AddEmailComponent'
import store from '../../../../redux/store'
import { setPdfEmail } from '../../../../redux/actions/pdfInputEmail'
import EditEmailComponent from '../NestedComponentOfModal/EditEmailComponent/EditEmailComponent'
import { setUserEmail } from '../../../../redux/actions/authActions'
import { setReimbursementRef } from '../../../../redux/actions/payment'

const SummaryDetails = () => {
  const dispatch = useDispatch()
  const ref = useSelector((state) => state.payment).reimbursementRef
  const email = useSelector((state) => state.userDetails).email
  const [careFileName, setcareFileName] = useState('')
  const [legalFileName, setlLegalFileName] = useState('')
  const accessToken = localStorage.getItem('accessToken')
  const [getPdfDisabled, setGetPdfDisabled] = useState(false)
  const { chooseCard, editedOption1 } = useSelector((state) => state.quizQuestions)
  const { inputEmail } = useSelector((state) => state.pdfInputEmail)
  const { additionalEmail } = useSelector((state) => state.quizQuestions)
  const { pathname } = window.location
  useEffect(() => {
    getReimbursements(ref).then((data) => {
      data.documents &&
        Object.keys(data.documents).forEach((key) => {
          if (key.includes('RC_CARE_RECIPIENT')) {
            data.templateParams.quizCareReceipients.quizCare.forEach((el) => {
              if (el.type === 'file') {
                el.answers = data.documents[key]
                data.params.careRecipients.certificate = data.documents[key]
              }
            })
          }
          if (key.includes('RC_LEGAL_REPRESENTATION')) {
            data.templateParams.quizLegalRepresentation.quizLegal.forEach((el) => {
              if (el.type === 'file') {
                el.answers = data.documents[key]
                data.params.legalRepresentations.document = data.documents[key]
              }
            })
          }
          // if (key) {
          //   data.templateParams.privateIndividual.quizPrivate.forEach((el) => {
          //     if (el.type === 'file') {
          //       el.answers = data.documents[key]
          //       data.params.representationByPrivateIndividual.receiptUpload =
          //         data.documents[key]
          //     }
          //   })
          // }
        })
      dispatch(updateQuiz({ ...data.templateParams, chooseCard: chooseCard }))

      dispatch(
        setUpdateCareQuizQuestions({
          lastName: data.params.careRecipients?.lastName,
          name: data.params.careRecipients?.name,
          birthday: data.params.careRecipients?.birthday,
          address: data.params.careRecipients?.address,
          houseNumber: data.params.careRecipients?.houseNumber,
          zipCode: data.params.careRecipients?.zipCode,
          city: data.params.careRecipients?.city,
          phoneNumber: data.params.careRecipients?.phoneNumber,
          insurance: data.params.careRecipients?.insurance,
          insuranceNumber: data.params.careRecipients?.insuranceNumber,
          levelOfCare: data.params.careRecipients?.levelOfCare,
          certificate: data.params.careRecipients?.certificate,
          legalRepresentation: data.params.careRecipients?.legalRepresentation,
        }),
      )
      dispatch(
        setUpdateLegalRepresentations({
          lastName: data.params.legalRepresentations?.lastName,
          name: data.params.legalRepresentations?.name,
          address: data.params.legalRepresentations?.address,
          houseNumber: data.params.legalRepresentations?.houseNumber,
          zipCode: data.params.legalRepresentations?.zipCode,
          city: data.params.legalRepresentations?.city,
          phoneNumber: data.params.legalRepresentations?.phoneNumber,
          document: data.params.legalRepresentations?.document,
        }),
      )
      dispatch(
        setUpdateAuthorizedPerson({
          lastName: data.params.authorizedPerson?.lastName,
          name: data.params.authorizedPerson?.name,
          birthday: data.params.authorizedPerson?.birthday,
          address: data.params.authorizedPerson?.address,
          houseNumber: data.params.authorizedPerson?.houseNumber,
          zipCode: data.params.authorizedPerson?.zipCode,
          city: data.params.authorizedPerson?.city,
          phoneNumber: data.params.authorizedPerson?.phoneNumber,
          professionalCarer: data.params.authorizedPerson?.professionalCarer,
          periodOfCare: data.params.authorizedPerson?.periodOfCare,
          periodOfAbsenceFrom: data.params.authorizedPerson?.periodOfAbsenceFrom,
          periodOfAbsenceTo: data.params.authorizedPerson?.periodOfAbsenceTo,
          reasonForTheAbsence: data.params.authorizedPerson?.reasonForTheAbsence,
          durationOfAbsence: data.params.authorizedPerson?.durationOfAbsence,
        }),
      )
      dispatch(
        setUpdateRepresentativePerson({
          lastName: data.params.representativePerson?.lastName,
          name: data.params.representativePerson?.name,
          address: data.params.representativePerson?.address,
          houseNumber: data.params.representativePerson?.houseNumber,
          zipCode: data.params.representativePerson?.zipCode,
          city: data.params.representativePerson?.city,
          phoneNumber: data.params.representativePerson?.phoneNumber,
          personRepresenting: data.params.representativePerson?.personRepresenting,
          commerciallyActive: data.params.representativePerson?.commerciallyActive,
          relationshipList: data.params.representativePerson?.relationshipList,
          relationshipByMarriage:
            data.params.representativePerson?.relationshipByMarriage,
          sameHousehold: data.params.representativePerson?.sameHousehold,
          relationship: data.params.representativePerson?.relationship,
        }),
      )
      // [...data.params.representationByCommerciallyActive]
      dispatch(
        setUpdateRepresentationByCommerciallyActive({
          activeDates: data.params?.representationByCommerciallyActive.activeDates,
          NameOfAccountHolder:
            data.params.representationByCommerciallyActive?.NameOfAccountHolder,
          IBAN: data.params.representationByCommerciallyActive?.IBAN,
          bank: data.params.representationByCommerciallyActive?.bank,
          ConsentToTheData:
            data.params.representationByCommerciallyActive?.ConsentToTheData,
          iAgree: data.params.representationByCommerciallyActive?.iAgree,
          iHave: data.params.representationByCommerciallyActive?.iHave,
          paid: data.params.representationByCommerciallyActive?.paid,
        }),
      )
      dispatch(
        setUpdateRepresentationByPrivateIndividual({
          individualDates:
            data?.params.representationByPrivateIndividual.individualDates,
          representingPersonByTransport:
            data.params.representationByPrivateIndividual
              ?.representingPersonByTransport,
          representingPersonByCar:
            data.params.representationByPrivateIndividual?.representingPersonByCar,
          zipCodeFrom: data.params.representationByPrivateIndividual?.zipCodeFrom,
          zipCodeTo: data.params.representationByPrivateIndividual?.zipCodeTo,
          travelCost: data.params.representationByPrivateIndividual?.travelCost,
          receiptUpload:
            data.params.representationByPrivateIndividual?.receiptUpload,
          earningsLoss: data.params.representationByPrivateIndividual?.earningsLoss,
          amount: data.params.representationByPrivateIndividual?.amount,
          NameOfAccountHolder:
            data.params.representationByPrivateIndividual?.NameOfAccountHolder,
          IBAN: data.params.representationByPrivateIndividual?.IBAN,
          bank: data.params.representationByPrivateIndividual?.bank,
          ConsentToTheData:
            data.params.representationByPrivateIndividual?.ConsentToTheData,
          iAgree: data.params.representationByPrivateIndividual?.iAgree,
          iHave: data.params.representationByPrivateIndividual?.iHave,
          paid: data.params.representationByPrivateIndividual?.paid,
        }),
      )
    })
  }, [careFileName, legalFileName])
  const handleGetPdf = () => {
    const requestBody = {
      ref: ref,
      email: email,
      option: 1,
    }
    const body = { ref, additionalEmails: additionalEmail }

    setGetPdfDisabled(true)
    accessToken &&
      getAuthUserPdf(body)
        .then(() => {
          dispatch(
            setToastNotification({
              type: 'success',
              toastTittle: 'Formular erfolgreich gesendet!',
              toastBody: 'Bitte überprüfen Sie Ihre E-Mails.',
            }),
          )
        })
        .catch((err) => console.log(err))
        .finally(() => setGetPdfDisabled(false))
    !accessToken &&
      getPdf(body)
        .then(() => {
          dispatch(
            setToastNotification({
              type: 'success',
              toastTittle: 'Formular erfolgreich gesendet!',
              toastBody: 'Bitte überprüfen Sie ihre E-Mails.',
            }),
          )
        })
        .catch((err) => console.log(err))
        .finally(() => setGetPdfDisabled(false))
    !!editedOption1 &&
      submitReimbursement(requestBody)
        .then(() => {
          // const body = { ref }
          getPdf(body)
            .then(() => {
              dispatch(
                setToastNotification({
                  type: 'success',
                  toastTittle: 'Formular erfolgreich gesendet!',
                  toastBody: 'Bitte überprüfen Sie ihre E-Mails.',
                }),
              )
            })
            .catch((err) => console.log(err))
            .finally(() => setGetPdfDisabled(false))
        })
        .catch((err) => console.log(err))
  }
  const addEmail = () => {
    const { pdfInputEmail } = store.getState()
    console.log(store.getState().pdfInputEmail)
    dispatch(
      setConfirmationModal({
        headerText: 'E-Mail hinzufügen',
        body: <AddEmailComponent />,
        confirm: {
          text: 'Speichern',
          smallPrimaryBg: true,
          // disabled: !inputEmail,
        },
        cancel: {
          text: 'Abbrechen',
          smallPrimaryNotBg: true,
        },
        large: true,
        handleCancel: () => dispatch(closeConfirmationModal()),
        handleConfirm: () => {
          const { pdfInputEmail } = store.getState()
          pdfInputEmail.inputEmail !== '' &&
            dispatch(
              setAdditionalEmail([...additionalEmail, pdfInputEmail.inputEmail]),
            )
          dispatch(setPdfEmail(''))
          dispatch(closeConfirmationModal())
        },
        form: {
          inputEmail: '',
          isInValid: true,
        },
      }),
    )
  }
  const deleteEmail = (item) => {
    dispatch(
      setAdditionalEmail(additionalEmail.filter((emailItem) => emailItem !== item)),
    )
  }
  const editEmail = (item, index) => {
    dispatch(
      setConfirmationModal({
        headerText: 'E-Mail bearbeiten',
        body: <EditEmailComponent item={item} />,
        confirm: {
          text: 'Speichern',
          smallPrimaryBg: true,
          // disabled: !inputEmail,
        },
        cancel: {
          text: 'Abbrechen',
          smallPrimaryNotBg: true,
        },
        large: true,
        handleCancel: () => dispatch(closeConfirmationModal()),
        handleConfirm: () => {
          const { pdfInputEmail } = store.getState()
          const updated = [...additionalEmail]
          updated[index] = pdfInputEmail.inputEmail
          {
            pdfInputEmail.inputEmail !== '' &&
              item !== email &&
              dispatch(setAdditionalEmail([...updated]))
          }
          {
            pdfInputEmail.inputEmail !== '' &&
              item === email &&
              dispatch(setUserEmail(pdfInputEmail.inputEmail))
          }
          upDateEmail(ref, { email: pdfInputEmail.inputEmail }).then(() => {
            dispatch(setPdfEmail(''))
            dispatch(closeConfirmationModal())
          })
        },
        form: {
          inputEmail: '',
          isInValid: true,
        },
      }),
    )
  }
  return (
    <div className={styles.summary}>
      {pathname === '/summary' && (
        <p>Hier können Sie Ihre Angaben überprüfen und gegebenenfalls anpassen:</p>
      )}
      <div>
        <Details />
        <div className={styles.getPdf}>
          <div>
            <img src={Robotik} alt={Robotik} />
          </div>
          <div>
            <div>
              <p>Ich schicke Ihnen Ihren Antrag gerne per E-Mail.</p>
              {
                <>
                  <div>
                    <input value={email} readOnly={true} />
                    {!accessToken && (
                      <div>
                        <img
                          src={Edit}
                          alt={Edit}
                          onClick={() => editEmail(email)}
                        />
                      </div>
                    )}
                  </div>
                  <p>
                    {additionalEmail?.length === 3
                      ? 'Auch schicken an:'
                      : 'Weitere E-Mail hinzufügen'}
                  </p>

                  {additionalEmail?.length > 0 &&
                    additionalEmail.map((item, index) => {
                      return (
                        typeof item === 'string' && (
                          <div>
                            <input value={item} />{' '}
                            <div key={index}>
                              <img
                                src={Delete}
                                alt={Delete}
                                onClick={() => deleteEmail(item)}
                              />
                              <img
                                src={Edit}
                                alt={Edit}
                                onClick={() => editEmail(item, index)}
                              />
                            </div>
                          </div>
                        )
                      )
                    })}

                  {additionalEmail?.length !== 3 && (
                    <button
                      onClick={addEmail}
                      // disabled={accessToken}
                      // className={cx({ [styles.addBtnDisabled]: accessToken })}
                    >
                      <img src={AddEmail} alt={AddEmail} />
                    </button>
                  )}
                </>
              }

              <button
                onClick={() => handleGetPdf()}
                className={cx({
                  [styles.disabled]: getPdfDisabled,
                })}
                disabled={getPdfDisabled}
              >
                PDF per E-Mail erhalten
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SummaryDetails
